import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button, mode, PopoverBody, PopoverContent, Portal, Tab, TabList, TabPanel, TabPanels, Tabs, Text, useColorMode } from '@abb/uikit';
import { useShowMore } from 'hooks';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { CampaignItem } from './CampaignPanel/CampaignItem';
import { EmptyTabPanel } from './EmptyPage';
import { NotificationItem } from './NotificationPanel/NotificationItem';
export function NotificatonCampaignTabs(param) {
    let { notificationList, campaignList, campaignsMutate, onDetailModalOpen } = param;
    const { t } = useTranslation('common');
    const { colorMode } = useColorMode();
    const { isCollapsed: showMoreVisible, hasMore: hasMoreList, toggle: toggleShowMore, data: notifList } = useShowMore(notificationList, 4);
    return /*#__PURE__*/ _jsx(Portal, {
        children: /*#__PURE__*/ _jsx(PopoverContent, {
            className: "popover",
            cursor: "pointer",
            color: "white",
            mt: "30px",
            background: mode('white', '#000000')({
                colorMode
            }),
            minW: {
                base: '100%',
                md: '312px'
            },
            borderRadius: "24px",
            h: "452px",
            mr: "24px",
            children: /*#__PURE__*/ _jsx(PopoverBody, {
                p: "1",
                borderRadius: "24px",
                background: mode('white', '#282829')({
                    colorMode
                }),
                children: /*#__PURE__*/ _jsxs(Tabs, {
                    borderRadius: "24px",
                    variant: "unstyled",
                    children: [
                        /*#__PURE__*/ _jsxs(TabList, {
                            p: "12px",
                            gap: "4px",
                            children: [
                                /*#__PURE__*/ _jsx(Tab, {
                                    p: 2,
                                    color: "#7A7D82",
                                    _selected: {
                                        color: 'white',
                                        bg: '#0A0B0D',
                                        borderRadius: '8px'
                                    },
                                    children: /*#__PURE__*/ _jsx(Text, {
                                        fontSize: "12px",
                                        fontWeight: 500,
                                        children: t('campaigns.whats_new')
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Tab, {
                                    p: "8px",
                                    color: "#7A7D82",
                                    _selected: {
                                        color: 'white',
                                        bg: '#0A0B0D',
                                        borderRadius: '8px'
                                    },
                                    children: /*#__PURE__*/ _jsx(Text, {
                                        fontSize: "12px",
                                        fontWeight: 500,
                                        children: t('notifications.title')
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs(TabPanels, {
                            overflow: "auto",
                            h: "400px",
                            children: [
                                /*#__PURE__*/ _jsx(TabPanel, {
                                    overflow: "auto",
                                    px: 3,
                                    children: (campaignList === null || campaignList === void 0 ? void 0 : campaignList.length) === 0 ? /*#__PURE__*/ _jsx(EmptyTabPanel, {
                                        title: t('campaigns.title'),
                                        content: t('campaigns.empty_notification')
                                    }) : campaignList === null || campaignList === void 0 ? void 0 : campaignList.map((item)=>/*#__PURE__*/ _jsx(CampaignItem, {
                                            mutate: campaignsMutate,
                                            item: item,
                                            onDetailModalOpen: ()=>onDetailModalOpen({
                                                    event: null,
                                                    type: 'campaign',
                                                    id: item.id
                                                })
                                        }, item.id))
                                }),
                                /*#__PURE__*/ _jsxs(TabPanel, {
                                    children: [
                                        notifList.length === 0 ? /*#__PURE__*/ _jsx(EmptyTabPanel, {
                                            title: t('notifications.title'),
                                            content: t('notifications.empty_notification')
                                        }) : notifList === null || notifList === void 0 ? void 0 : notifList.map((item)=>/*#__PURE__*/ _jsx(NotificationItem, {
                                                notification: item,
                                                onDetailModalOpen: ()=>onDetailModalOpen({
                                                        event: item.event,
                                                        type: 'notification',
                                                        id: item.id
                                                    })
                                            }, item.id)),
                                        hasMoreList && /*#__PURE__*/ _jsx(Box, {
                                            width: "100%",
                                            background: mode('white', 'rgba(41, 41, 41, 0.90)')({
                                                colorMode
                                            }),
                                            children: /*#__PURE__*/ _jsx(Button, {
                                                id: "show-morebutton",
                                                onClick: toggleShowMore,
                                                fontSize: "14px",
                                                fontWeight: 600,
                                                border: "none",
                                                background: "none",
                                                height: "53px",
                                                color: "#3B8DD4",
                                                _hover: {
                                                    background: 'none'
                                                },
                                                _focus: {
                                                    boxShadow: 'none !important'
                                                },
                                                _active: {
                                                    background: 'none',
                                                    outline: 'none',
                                                    border: 'none'
                                                },
                                                children: showMoreVisible ? t('notifications.more') : t('notifications.less')
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
}
